import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField, Fieldset } from '@components';

export const NameSubModule = () => {
  const { t } = useTranslation('subModules/name');
  const { getValues, setValue } = useFormContext();

  const name =
    (getValues('firstName') ?? '') + ' ' + (getValues('lastName') ?? '');

  useEffect(() => {
    setValue('fullName', name);
  }, [name, setValue]);

  return (
    <Fieldset label={t('Title')} required>
      <ControlledTextField
        label={t('FirstNameLabel')}
        placeholder="John"
        fieldName="firstName"
        data-testid="firstNameTestId"
        data-tf-sensitive="false"
      />
      <ControlledTextField
        label={t('LastNameLabel')}
        placeholder="Smith"
        fieldName="lastName"
        data-testid="lastNameTestId"
        data-tf-sensitive="false"
      />
    </Fieldset>
  );
};
